import { createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import { useMemo } from "react";

import { PRIMARY_COLOR } from "./utils";
import { Content } from "./components";
import { useDarkMode } from "./hooks/useDarkMode";
import "./App.css";

export const App = () => {
    const { isDark, toggle } = useDarkMode();

    const theme = useMemo(() => createTheme({
        palette: {
            mode: isDark ? "dark" : "light",
            primary: {
                main: PRIMARY_COLOR,
            },
            secondary: {
                main: "#555",
            },
            background: {
                default: isDark ? "rgb(27, 29, 50)" : "#ffffff",
                paper: isDark ? "rgb(37, 39, 70)" : "#ffffff",
            },
        },
    }), [isDark]);

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Content isDark={isDark} onToggleDarkMode={toggle} />
        </ThemeProvider>
    );
};
